// Central source of truth for public business/legal info.
// NOTE: `email` is a placeholder — swap it with the real contact address when provided.
export const SITE = {
  displayName: "SIBLINGO",
  legalName: "Shopping With Guidelines Corp",
  domain: "siblingo.co",
  email: "contact@siblingo.co",
  address: "250 Remsen Ave #212, Monsey, NY 10952",
  tagline: "Dressed. Matched. Done.",
};

export const AFFILIATE_DISCLOSURE =
  "SIBLINGO may earn a commission when you buy through eligible retailer links. Using an affiliate link does not add a separate fee from SIBLINGO; retailer prices and offers may change.";

// Feature flag: hide the Sales / Free Giveaways / Marketplace sections site-wide.
// Set to false to restore them everywhere (nav, tabs, Home cards, routes) — no code was deleted.
// Driven by the sales-division feature flag (REACT_APP_SALES_DIVISION_ENABLED). Default: hidden. Backend mirrors it via SALES_DIVISION_ENABLED.
export const HIDE_SALES = process.env.REACT_APP_SALES_DIVISION_ENABLED !== "true";

// Feature flags: hide the Latest Deals tab and the Loved Sales tab/section (nav + Know Me).
// Set to false to restore — underlying pages/routes/code are untouched.
export const HIDE_LATEST_DEALS = true;
export const HIDE_LOVED = true;

// Prelaunch: everything available today is free. Hides Post a Deal / Deal Statistics / Loved Deals / Upgrade to Premium
// entries, the trial clock and premium perk claims. Data, routes and code stay intact — set to false to restore.
export const PRELAUNCH_FREE = true;
